/**
 * @typedef {Object} Device
 * @property {string} name
 * @property {string} ip_address
 * @property {boolean} device_status
 * @property {string} last_update
 * @property {Component[]} component
 * @property {Network[] | undefined} network
 * @property {Traffic[] | undefined} traffic
 */



/**
 * @typedef {Object} Component
 * @property {string} type
 * @property {Core[]} [cores]
 * @property {Core[]} [indexes]
 * @property {Core[]} [partitions]
 */

/**
 * @typedef {Object} Core
 * @property {string} [core]
 * @property {string} value
 * @property {null} level
 * @property {number} id
 * @property {string} [index]
 * @property {string} [partition]
 */

/**
 * @typedef {Object} Network
 * @property {string} type
 * @property {number} value
 * @property {string} level
 */

/**
 * @typedef {Object} Traffic
 * @property {string} type
 * @property {Interface[]} interface
 */

/**
 * @typedef {Object} Interface
 * @property {string} interface
 * @property {number} in_value
 * @property {number} out_value
 * @property {string} in_metric
 * @property {string} out_metric
 * @property {number} in_percentage
 * @property {number} out_percentage
 * @property {number} max_capacity
 * @property {string} max_capacity_metric
 * @property {string} level
 * @property {string} status
 */

/**
 * @typedef {Object} DeviceComponentData
 * @property {string} type
 * @property {number} value
 * @property {string} level
 * @property {string} id
 */

// typedef rootCause
// example: {cpu: ["core1", "core2"]}
// example: {memory: ["index1", "index2"]}

/**
 *
 * @param {Device} device
 * @returns {{cpuData: DeviceComponentData[], memoryData: DeviceComponentData[], storageData: DeviceComponentData[], rootCause: string[]}}
 */

export const isRootCauseEmpty = (rootCause) => {
  console.log("rootCause", rootCause);
  return JSON.stringify(rootCause) === JSON.stringify([
    { cpu: [] },
    { cpuUnderutilized: [] },
    { memory: [] },
    { memoryUnderutilized: [] },
    { storage: [] },
    { storageUnderutilized: [] },
    { latency: [] },
    { jitter: [] },
    { packetLoss: [] },
    { traffic: [] },
    { cpuServer: [] },
    { cpuUnderutilizedServer: [] },
    { memoryServer: [] },
    { memoryUnderutilizedServer: [] },
    { storageServer: [] },
    { storageUnderutilizedServer: [] },
    { processCPU: [] },
    { processMemory: [] },
    { containerCPU: [] },
    { containerMemory: [] },
  ])
}
export const loopRootCause = (device) => {
  let rootCauseList = [
    { cpu: [] },
    { cpuUnderutilized: [] },
    { memory: [] },
    { memoryUnderutilized: [] },
    { storage: [] },
    { storageUnderutilized: [] },
    { latency: [] },
    { jitter: [] },
    { packetLoss: [] },
    { traffic: [] },
    { cpuServer: [] },
    { cpuUnderutilizedServer: [] },
    { memoryServer: [] },
    { memoryUnderutilizedServer: [] },
    { storageServer: [] },
    { storageUnderutilizedServer: [] },
    { processCPU: [] },
    { processMemory: [] },
    { containerCPU: [] },
    { containerMemory: [] },
  ];

  console.log("device", device);

  // loop for component (cpu)
  let tempCpu = [];
  if (device.component[0] && device.component[0].cores) {
    for (let i = 0; i < device.component[0].cores.length; i++) {
      if (
        device.component[0].cores[i].value !== "no_data" ||
        device.component[0].cores[i].level !== null
      ) {
        let tempData = {
          value: device.component[0].cores[i].value,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level,
          id: device.component[0].cores[i].id,
        };
        tempCpu.push(tempData);
        if (
          device.component[0].cores[i].level === "warning" ||
          device.component[0].cores[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpu) {
              if (
                element.cpu.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpu.push(
                  element.cpu.length === 0 ? `CPU usage on core ${device.component[0].cores[i].core} is ${device.component[0].cores[i].level} ${device.component[0].cores[i].level === "warning" ? "(>50%)" : "(>80%)"}` : `,
                  CPU usage on core ${device.component[0].cores[i].core} is ${device.component[0].cores[i].level} ${device.component[0].cores[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
      }
      // if cpu value under 30%
      if (device.component[0].cores[i].value < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilized) {
            if (
              element.cpuUnderutilized.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilized.push(element.cpuUnderutilized.length === 0 ? `CPU usage on core ${device.component[0].cores[i].core}` : `,
                ${device.component[0].cores[i].core}`);
            }
          }
        });
      }
    }
  }

  // loop for component (memory)
  let tempMemory = [];
  if (device.component[1] && device.component[1].indexes) {
    for (let i = 0; i < device.component[1].indexes.length; i++) {
      if (
        device.component[1].indexes[i].value !== "no_data" ||
        device.component[1].indexes[i].level !== null
      ) {
        let tempData = {
          value: device.component[1].indexes[i].value,
          type: device.component[1].indexes[i].index,
          level: device.component[1].indexes[i].level,
          id: device.component[1].indexes[i].id,
        };
        tempMemory.push(tempData);
        if (
          device.component[1].indexes[i].level === "warning" ||
          device.component[1].indexes[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.memory) {
              if (
                element.memory.indexOf(device.component[1].indexes[i].index) ===
                -1
              ) {
                element.memory.push(element.memory.length === 0 ? `Memory usage on type ${device.component[1].indexes[i].index} is ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `, ${device.component[1].indexes[i].index} is ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if memory value under 30%
        if (device.component[1].indexes[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.memoryUnderutilized) {
              if (element.memoryUnderutilized.indexOf(device.component[1].indexes[i].index) === -1
              ) {
                element.memoryUnderutilized.push(element.memoryUnderutilized.length === 0 ? `Memory usage on type ${device.component[1].indexes[i].index}` : `, ${device.component[1].indexes[i].index}`);
                
              }
            }
          });
        }
      }
    }
  }

  // loop for component (storage)
  let tempStorage = [];
  if (device.component[2] && device.component[2].partitions) {
    for (let i = 0; i < device.component[2].partitions.length; i++) {
      if (
        device.component[2].partitions[i].value !== "no_data" ||
        device.component[2].partitions[i].level !== null
      ) {
        let tempData = {
          value: device.component[2].partitions[i].value,
          type: device.component[2].partitions[i].partition,
          level: device.component[2].partitions[i].level,
          id: device.component[2].partitions[i].id,
        };
        tempStorage.push(tempData);
        if (
          device.component[2].partitions[i].level === "warning" ||
          device.component[2].partitions[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.storage) {
              if (
                element.storage.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storage.push(element.storage.length === 0 ? `Storage usage on partition ${device.component[2].partitions[i].partition} is ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `, ${device.component[2].partitions[i].partition} is ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                 
                );
              }
            }
          });
        }
        // if storage value under 30%
        if (device.component[2].partitions[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.storageUnderutilized) {
              if (
                element.storageUnderutilized.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageUnderutilized.push(element.storageUnderutilized.length === 0 ? `Storage usage on ${device.component[2].partitions[i].partition}` : `, ${device.component[2].partitions[i].partition}`);
              }
            }
          });
        }
      }
    }
  }
  // set for network
  if (device.network && device.network.length > 0) {
    if (
      device.network[0].level === "poor" ||
      device.network[0].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.latency) {
          element.latency.push(`Network latency is ${device.network[0].level}`);
        }
      });
    }

    if (
      device.network[1].level === "poor" ||
      device.network[1].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.jitter) {
          element.jitter.push(`Network jitter is ${device.network[1].level}`);
        }
      });
    }

    if (
      device.network[2].level === "poor" ||
      device.network[2].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.packetLoss) {
          element.packetLoss.push(`Network packet loss is ${device.network[2].level}`);
        }
      });
    }
  }

  // set for traffic
  if (device.traffic && device.traffic.length > 0) {
    // loop for traffic interface, if in_percentage > 80% or out_percentage > 80% then push to rootCauseList
    for (let i = 0; i < device.traffic[0].interface.length; i++) {
      
      if (
        device.traffic[0].interface[i].in_percentage > 80 ||
        device.traffic[0].interface[i].out_percentage > 80
      ) {
        rootCauseList.map((element) => {
          if (element.traffic) {
            element.traffic.push(element.traffic.length === 0 ? `Traffic on ${device.traffic[0].interface[i].interface}` : `, ${device.traffic[0].interface[i].interface}`);
              
          }
        });
      }
    }
  }

  rootCauseList.forEach((element) => {
    if (element.cpuUnderutilized) {
      if (element.cpuUnderutilized.length > 1) {
        element.cpuUnderutilized.push(" are underutilized");
      } else if (element.cpuUnderutilized.length === 1) {
        element.cpuUnderutilized.push(" is underutilized");
      }
    }
    if (element.memoryUnderutilized) {
      if (element.memoryUnderutilized.length > 1) {
        element.memoryUnderutilized.push(" are underutilized");
      } else if (element.memoryUnderutilized.length === 1) {
        element.memoryUnderutilized.push(" is underutilized");
      }
    }
    if (element.storageUnderutilized) {
      if (element.storageUnderutilized.length > 1) {
        element.storageUnderutilized.push(" are underutilized");
      } else if (element.storageUnderutilized.length === 1) {
        element.storageUnderutilized.push(" is underutilized");
      }
    }
    if (element.traffic) {
      if (element.traffic.length > 1) {
        element.traffic.push(" are high");
      } else if (element.traffic.length === 1) {
        element.traffic.push(" is high");
      }

    }
  });

  console.log("rootCauseList", rootCauseList);

  return {
    cpuData: tempCpu.sort((a, b) => b.value - a.value),
    memoryData: tempMemory.sort((a, b) => b.value - a.value),
    storageData: tempStorage.sort((a, b) => b.value - a.value),
    rootCause: rootCauseList,
  };
};

export const loopRootCauseID = (device) => {
  let rootCauseList = [
    { cpu: [] },
    { cpuUnderutilized: [] },
    { memory: [] },
    { memoryUnderutilized: [] },
    { storage: [] },
    { storageUnderutilized: [] },
    { latency: [] },
    { jitter: [] },
    { packetLoss: [] },
    { traffic: [] },
    { cpuServer: [] },
    { cpuUnderutilizedServer: [] },
    { memoryServer: [] },
    { memoryUnderutilizedServer: [] },
    { storageServer: [] },
    { storageUnderutilizedServer: [] },
    { processCPU: [] },
    { processMemory: [] },
    { containerCPU: [] },
    { containerMemory: [] },
  ];

  console.log("device", device);

  // loop for component (cpu)
  let tempCpu = [];
  if (device.component[0] && device.component[0].cores) {
    for (let i = 0; i < device.component[0].cores.length; i++) {
      if (
        device.component[0].cores[i].value !== "no_data" ||
        device.component[0].cores[i].level !== null
      ) {
        let tempData = {
          value: device.component[0].cores[i].value,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level,
          id: device.component[0].cores[i].id,
        };
        tempCpu.push(tempData);
        if (
          device.component[0].cores[i].level === "warning" ||
          device.component[0].cores[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpu) {
              if (
                element.cpu.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpu.push(
                  element.cpu.length === 0 ? `Penggunaan CPU pada core ${device.component[0].cores[i].core} adalah ${device.component[0].cores[i].level} ${device.component[0].cores[i].level === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `,
                  Penggunaan CPU pada core ${device.component[0].cores[i].core} adalah ${device.component[0].cores[i].level} ${device.component[0].cores[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
      }
      // if cpu value under 30%
      if (device.component[0].cores[i].value < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilized) {
            if (
              element.cpuUnderutilized.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilized.push(element.cpuUnderutilized.length === 0 ? `Penggunaan CPU pada ${device.component[0].cores[i].core}` : `,
                ${device.component[0].cores[i].core}`);
            }
          }
        });
      }
    }
  }

  // loop for component (memory)
  let tempMemory = [];
  if (device.component[1] && device.component[1].indexes) {
    for (let i = 0; i < device.component[1].indexes.length; i++) {
      if (
        device.component[1].indexes[i].value !== "no_data" ||
        device.component[1].indexes[i].level !== null
      ) {
        let tempData = {
          value: device.component[1].indexes[i].value,
          type: device.component[1].indexes[i].index,
          level: device.component[1].indexes[i].level,
          id: device.component[1].indexes[i].id,
        };
        tempMemory.push(tempData);
        if (

          device.component[1].indexes[i].level === "warning" ||
          device.component[1].indexes[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.memory) {
              if (
                element.memory.indexOf(device.component[1].indexes[i].index) ===
                -1
              ) {
                element.memory.push(element.memory.length === 0 ? `Penggunaan Memori pada tipe ${device.component[1].indexes[i].index} adalah ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `, ${device.component[1].indexes[i].index} adalah ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if memory value under 30%
        if (device.component[1].indexes[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.memoryUnderutilized) {
              if (element.memoryUnderutilized.indexOf(device.component[1].indexes[i].index) === -1
              ) {
                element.memoryUnderutilized.push(element.memoryUnderutilized.length === 0 ? `Penggunaan Memori pada tipe ${device.component[1].indexes[i].index}` : `, ${device.component[1].indexes[i].index}`);

              }
            }
          });
        }
      }
    }
  }

  // loop for component (storage)
  let tempStorage = [];
  if (device.component[2] && device.component[2].partitions) {
    for (let i = 0; i < device.component[2].partitions.length; i++) {

      if (
        device.component[2].partitions[i].value !== "no_data" ||
        device.component[2].partitions[i].level !== null
      ) {
        let tempData = {
          value: device.component[2].partitions[i].value,
          type: device.component[2].partitions[i].partition,
          level: device.component[2].partitions[i].level,
          id: device.component[2].partitions[i].id,
        };
        tempStorage.push(tempData);
        if (
          device.component[2].partitions[i].level === "warning" ||
          device.component[2].partitions[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.storage) {
              if (
                element.storage.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storage.push(element.storage.length === 0 ? `Penggunaan Storage pada partisi ${device.component[2].partitions[i].partition} adalah ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `, ${device.component[2].partitions[i].partition} adalah ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if storage value under 30%
        if (device.component[2].partitions[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.storageUnderutilized) {
              if (
                element.storageUnderutilized.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageUnderutilized.push(element.storageUnderutilized.length === 0 ? `Penggunaan Storage pada partisi ${device.component[2].partitions[i].partition}` : `, ${device.component[2].partitions[i].partition}`);
              }
            }
          });
        }
      }
    }
  }

  // set for network
  if (device.device_status){
  if (device.network && device.network.length > 0) {
    if (
      device.network[0].level === "poor" ||
      device.network[0].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.latency) {
          element.latency.push(`Latensi jaringan dalam kondisi ${device.network[0].level}`); 
        }
      });
    }

    if (
      device.network[1].level === "poor" ||
      device.network[1].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.jitter) {
          element.jitter.push(`Jitter jaringan dalam kondisi ${device.network[1].level}`);
        }
      });
    }

    if (
      device.network[2].level === "poor" ||
      device.network[2].level === "fair"
    ) {
      rootCauseList.map((element) => {
        if (element.packetLoss) {
          element.packetLoss.push(`Packet loss jaringan dalam kondisi ${device.network[2].level}`);
        }
      });
    }
  }
}

  // set for traffic
  if (device.traffic && device.traffic.length > 0) {
    // loop for traffic interface, if in_percentage > 80% or out_percentage > 80% then push to rootCauseList
    for (let i = 0; i < device.traffic[0].interface.length; i++) {
      if (
        device.traffic[0].interface[i].in_percentage > 80 ||
        device.traffic[0].interface[i].out_percentage > 80
      ) {
        rootCauseList.map((element) => {
          if (element.traffic) {
            element.traffic.push(element.traffic.length === 0 ? `Traffic pada ${device.traffic[0].interface[i].interface}` : `, ${device.traffic[0].interface[i].interface}`);
          }
        });
      }
    }
  }

  rootCauseList.forEach((element) => {
    if (element.cpuUnderutilized) {
      if (element.cpuUnderutilized.length > 0) {
        element.cpuUnderutilized.push(" tidak optimal");
      }
    }
    if (element.memoryUnderutilized) {
      if (element.memoryUnderutilized.length > 0) {
        element.memoryUnderutilized.push(" tidak optimal");
    }
  }
    if (element.storageUnderutilized) {
      if (element.storageUnderutilized.length > 0) {
        element.storageUnderutilized.push(" tidak optimal");
      }
    }
    if (element.traffic) {
      if (element.traffic.length > 0) {
        element.traffic.push(" tinggi");
      } 

    }
  });


  console.log("rootCauseList", rootCauseList);

  return {
    cpuData: tempCpu.sort((a, b) => b.value - a.value),
    memoryData: tempMemory.sort((a, b) => b.value - a.value),
    storageData: tempStorage.sort((a, b) => b.value - a.value),
    rootCause: rootCauseList,
  };
};





export const loopRootCauseServer = (device) => {
  let rootCauseList = [
    { cpu: [] },
    { cpuUnderutilized: [] },
    { memory: [] },
    { memoryUnderutilized: [] },
    { storage: [] },
    { storageUnderutilized: [] },
    { latency: [] },
    { jitter: [] },
    { packetLoss: [] },
    { traffic: [] },
    { cpuServer: [] },
    { cpuUnderutilizedServer: [] },
    { memoryServer: [] },
    { memoryUnderutilizedServer: [] },
    { storageServer: [] },
    { storageUnderutilizedServer: [] },
    { processCPU: [] },
    { processMemory: [] },
    { containerCPU: [] },
    { containerMemory: [] },

  ];

  console.log("device", device);

  // loop for component (cpu)
  let tempCpu = [];
  let tempCpuUser = [];
  if (device.component[0] && device.component[0].cores) {
    for (let i = 0; i < device.component[0].cores.length; i++) {
      if (
        device.component[0].cores[i].value !== "no_data" ||
        device.component[0].cores[i].level !== null
      ) {
        let tempData = {
          value: device.component[0].cores[i].value_system,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level_system,
          id: device.component[0].cores[i].id,
        };
        tempCpu.push(tempData);
        let tempDataUser = {
          value: device.component[0].cores[i].value_user,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level_user,
          id: device.component[0].cores[i].id,
        };
        tempCpuUser.push(tempDataUser);
        if (
          device.component[0].cores[i].level_system === "warning" ||
          device.component[0].cores[i].level_system === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpuServer) {
              if (
                element.cpuServer.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpuServer.push(
                  `CPU system is ${device.component[0].cores[i].level_system} ${device.component[0].cores[i].level_system === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }

        if (
          device.component[0].cores[i].level_user === "warning" ||
          device.component[0].cores[i].level_user === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpuServer) {
              if (
                element.cpuServer.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpuServer.push(element.cpuServer.length === 0 ? `CPU user is ${device.component[0].cores[i].level_user} ${device.component[0].cores[i].level_user === "warning" ? "(>50%)" : "(>80%)"}
                  ` : `,
                  CPU user is ${device.component[0].cores[i].level_user} ${device.component[0].cores[i].level_user === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
      }
      // if cpu value under 30%
      if (device.component[0].cores[i].value_system < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilizedServer) {
            if (
              element.cpuUnderutilizedServer.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilizedServer.push('CPU system is underutilized');
            }
          }
        });
      }


      if (device.component[0].cores[i].value_user < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilizedServer) {
            if (
              element.cpuUnderutilizedServer.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilizedServer.push(element.cpuUnderutilizedServer.length === 0 ? 'CPU user is underutilized' : ', CPU user is underutilized');
                
            }
          }
        });
      }
    }
  }


  // MEMORY
  let tempMemory = [];
  if (device.component[1] && device.component[1].indexes) {
    for (let i = 0; i < device.component[1].indexes.length; i++) {
      if (
        device.component[1].indexes[i].value !== "no_data" ||
        device.component[1].indexes[i].level !== null
      ) {
        let tempData = {
          value: device.component[1].indexes[i].value,
          type: device.component[1].indexes[i].index,
          level: device.component[1].indexes[i].level,
          id: device.component[1].indexes[i].id,
        };
        tempMemory.push(tempData);
        if (
          device.component[1].indexes[i].level === "warning" ||
          device.component[1].indexes[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.memoryServer) {
              if (
                element.memoryServer.indexOf(device.component[1].indexes[i].index) ===
                -1
              ) {
                element.memoryServer.push(
                  `Server memory is ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if memory value under 30%
        if (device.component[1].indexes[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.memoryUnderutilizedServer) {
              if (
                element.memoryUnderutilizedServer.indexOf(
                  device.component[1].indexes[i].index
                ) === -1
              ) {
                element.memoryUnderutilizedServer.push(
                  'Server memory is underutilized'
                );
              }
            }
          });
        }
      }
    }
  }

  // loop for component (storage)
  let tempStorage = [];
  if (device.component[2] && device.component[2].partitions) {
    for (let i = 0; i < device.component[2].partitions.length; i++) {
      if (
        device.component[2].partitions[i].value !== "no_data" ||
        device.component[2].partitions[i].level !== null
      ) {
        let tempData = {
          value: device.component[2].partitions[i].value,
          type: device.component[2].partitions[i].partition,
          level: device.component[2].partitions[i].level,
          id: device.component[2].partitions[i].id,
        };
        tempStorage.push(tempData);
        if (
          device.component[2].partitions[i].level === "warning" ||
          device.component[2].partitions[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.storageServer) {
              if (
                element.storageServer.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageServer.push(
                  `Server storage is ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if storage value under 30%
        if (device.component[2].partitions[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.storageUnderutilizedServer) {
              if (
                element.storageUnderutilizedServer.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageUnderutilizedServer.push(
                  'Server storage is underutilized'
                );
              }
            }
          });
        }
      }
    }
  }

  // set for process

  if (device.process && device.process.length > 0) {
    for (let i = 0; i < device.process.length; i++) {
      if (device.process[i].cpu_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.processCPU) {
            if (element.processCPU.indexOf(device.process[i].name) === -1) {
              element.processCPU.push(
                element.processCPU.length === 0 ? `CPU usage on process ${device.process[i].process_name} is ${device.process[i].cpu_usage}%` : `, ${device.process[i].process_name} is ${device.process[i].cpu_usage}%`);
            }
          }
        });
      }
      if (device.process[i].mem_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.processMemory) {
            if (element.processMemory.indexOf(device.process[i].name) === -1) {
              element.processMemory.push(
                element.processMemory.length === 0 ? `Memory usage on process ${device.process[i].process_name} is ${device.process[i].mem_usage}%` : `, ${device.process[i].process_name} is ${device.process[i].mem_usage}%`);
            }
          }
        });
      }
    }
  }

  // set for container
  if (device.container && device.container.length > 0) {
    for (let i = 0; i < device.container.length; i++) {
      if (device.container[i].cpu_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.containerCPU) {
            if (element.containerCPU.indexOf(device.container[i].name) === -1) {
              element.containerCPU.push(element.containerCPU.length === 0 ? `CPU usage on container ${device.container[i].container_name} is ${device.container[i].cpu_usage}%` : `, ${device.container[i].container_name} is ${device.container[i].cpu_usage}%`);
            }
          }
        });
      }
      if (device.container[i].mem_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.containerMemory) {
            if (element.containerMemory.indexOf(device.container[i].name) === -1) {
              element.containerMemory.push(element.containerMemory.length === 0 ? `Memory usage on container ${device.container[i].container_name} is ${device.container[i].mem_usage}%` : `, ${device.container[i].container_name} is ${device.container[i].mem_usage}%`);
            }
          }
        });
      }
    }
  }

  console.log("rootCauseList", rootCauseList);


  return {
    cpuData: tempCpu.sort((a, b) => b.value - a.value),
    cpuUserData: tempCpuUser.sort((a, b) => b.value - a.value),
    memoryData: tempMemory.sort((a, b) => b.value - a.value),
    storageData: tempStorage.sort((a, b) => b.value - a.value),
    rootCause: rootCauseList,
  };
}


export const loopRootCauseServerID = (device) => {
  let rootCauseList = [
    { cpu: [] },
    { cpuUnderutilized: [] },
    { memory: [] },
    { memoryUnderutilized: [] },
    { storage: [] },
    { storageUnderutilized: [] },
    { latency: [] },
    { jitter: [] },
    { packetLoss: [] },
    { traffic: [] },
    { cpuServer: [] },
    { cpuUnderutilizedServer: [] },
    { memoryServer: [] },
    { memoryUnderutilizedServer: [] },
    { storageServer: [] },
    { storageUnderutilizedServer: [] },
    { processCPU: [] },
    { processMemory: [] },
    { containerCPU: [] },
    { containerMemory: [] },
  ];

  console.log("device", device);

  // loop for component (cpu)
  let tempCpu = [];
  let tempCpuUser = [];
  if (device.component[0] && device.component[0].cores) {
    for (let i = 0; i < device.component[0].cores.length; i++) {
      if (
        device.component[0].cores[i].value !== "no_data" ||
        device.component[0].cores[i].level !== null
      ) {
        let tempData = {
          value: device.component[0].cores[i].value_system,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level_system,
          id: device.component[0].cores[i].id,
        };
        tempCpu.push(tempData);
        let tempDataUser = {
          value: device.component[0].cores[i].value_user,
          type: device.component[0].cores[i].core,
          level: device.component[0].cores[i].level_user,
          id: device.component[0].cores[i].id,
        };
        tempCpuUser.push(tempDataUser);
        if (
          device.component[0].cores[i].level_system === "warning" ||
          device.component[0].cores[i].level_system === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpuServer) {
              if (
                element.cpuServer.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpuServer.push(
                  `Penggunaan CPU system ${device.component[0].cores[i].level_system} ${device.component[0].cores[i].level_system === 'warning' ? '(>50%)' : '(>80%)'}`
                );
              }
            }
          });
        }

        if (
          device.component[0].cores[i].level_user === "warning" ||
          device.component[0].cores[i].level_user === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.cpuServer) {
              if (
                element.cpuServer.indexOf(device.component[0].cores[i].core) === -1
              ) {
                element.cpuServer.push(element.cpuServer.length === 0 ? `CPU user ${device.component[0].cores[i].level_user} ${device.component[0].cores[i].level_user === 'warning' ? '(>50%)' : '(>80%)'}` : `, CPU user ${device.component[0].cores[i].level_user} ${device.component[0].cores[i].level_user === 'warning' ? '(>50%)' : '(>80%)'}`
                );
              }
            }
          }
        )
        }

      }
      // if cpu value under 30%
      if (device.component[0].cores[i].value_system < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilizedServer) {
            if (
              element.cpuUnderutilizedServer.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilizedServer.push('Penggunaan CPU system tidak optimal');
            }
          }
        });
      }


      if (device.component[0].cores[i].value_user < 30) {
        rootCauseList.forEach((element) => {
          if (element.cpuUnderutilizedServer) {
            if (
              element.cpuUnderutilizedServer.indexOf(
                device.component[0].cores[i].core
              ) === -1
            ) {
              element.cpuUnderutilizedServer.push(element.cpuUnderutilizedServer.length === 0 ? 'Penggunaan CPU user tidak optimal' : ', Penggunaan CPU user tidak optimal');
            }
          }
        });
      }

    }

  }


  // MEMORY
  let tempMemory = [];
  if (device.component[1] && device.component[1].indexes) {
    for (let i = 0; i < device.component[1].indexes.length; i++) {
      if (
        device.component[1].indexes[i].value !== "no_data" ||
        device.component[1].indexes[i].level !== null
      ) {
        let tempData = {
          value: device.component[1].indexes[i].value,
          type: device.component[1].indexes[i].index,
          level: device.component[1].indexes[i].level,
          id: device.component[1].indexes[i].id,
        };
        tempMemory.push(tempData);
        if (
          device.component[1].indexes[i].level === "warning" ||
          device.component[1].indexes[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.memoryServer) {
              if (
                element.memoryServer.indexOf(device.component[1].indexes[i].index) ===
                -1
              ) {
                element.memoryServer.push(
                  `Penggunaan Memori server ${device.component[1].indexes[i].level} ${device.component[1].indexes[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if memory value under 30%
        if (device.component[1].indexes[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.memoryUnderutilizedServer) {
              if (
                element.memoryUnderutilizedServer.indexOf(
                  device.component[1].indexes[i].index
                ) === -1
              ) {
                element.memoryUnderutilizedServer.push(
                  'Penggunaan memori server tidak optimal'
                );
              }
            }
          });
        }
      }
    }
  }

  // loop for component (storage)
  let tempStorage = [];
  if (device.component[2] && device.component[2].partitions) {
    for (let i = 0; i < device.component[2].partitions.length; i++) {
      if (
        device.component[2].partitions[i].value !== "no_data" ||
        device.component[2].partitions[i].level !== null
      ) {
        let tempData = {
          value: device.component[2].partitions[i].value,
          type: device.component[2].partitions[i].partition,
          level: device.component[2].partitions[i].level,
          id: device.component[2].partitions[i].id,
        };
        tempStorage.push(tempData);
        if (
          device.component[2].partitions[i].level === "warning" ||
          device.component[2].partitions[i].level === "critical"
        ) {
          rootCauseList.forEach((element) => {
            if (element.storageServer) {
              if (
                element.storageServer.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageServer.push(
                  `Penggunaan Storage server ${device.component[2].partitions[i].level} ${device.component[2].partitions[i].level === "warning" ? "(>50%)" : "(>80%)"}`
                );
              }
            }
          });
        }
        // if storage value under 30%
        if (device.component[2].partitions[i].value < 30) {
          rootCauseList.forEach((element) => {
            if (element.storageUnderutilizedServer) {
              if (
                element.storageUnderutilizedServer.indexOf(
                  device.component[2].partitions[i].partition
                ) === -1
              ) {
                element.storageUnderutilizedServer.push(
                  'Penggunaan storage server tidak optimal'
                );
              }
            }
          });
        }
      }
    }
  }

  // set for process

  if (device.process && device.process.length > 0) {
    for (let i = 0; i < device.process.length; i++) {
      if (device.process[i].cpu_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.processCPU) {
            if (element.processCPU.indexOf(device.process[i].name) === -1) {
              element.processCPU.push(
                element.processCPU.length === 0 ? `Penggunaan CPU pada process ${device.process[i].process_name} sebesar ${device.process[i].cpu_usage}%` : `, ${device.process[i].process_name} sebesar ${device.process[i].cpu_usage}%`);
            }
          }
        });
      }
      if (device.process[i].mem_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.processMemory) {
            if (element.processMemory.indexOf(device.process[i].name) === -1) {
              element.processMemory.push(
                element.processMemory.length === 0 ? `Penggunaan Memori pada process ${device.process[i].process_name} sebesar ${device.process[i].mem_usage}%` : `, ${device.process[i].process_name} sebesar ${device.process[i].mem_usage}%`);
            }
          }
        });
      }
    }
  }

  // set for container

  if (device.container && device.container.length > 0) {
    for (let i = 0; i < device.container.length; i++) {
      if (device.container[i].cpu_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.containerCPU) {
            if (element.containerCPU.indexOf(device.container[i].name) === -1) {
              element.containerCPU.push(element.containerCPU.length === 0 ? `Penggunaan CPU pada container ${device.container[i].container_name} sebesar ${device.container[i].cpu_usage}%` : `, ${device.container[i].container_name} sebesar ${device.container[i].cpu_usage}%`);
            }
          }
        });
      }
      if (device.container[i].mem_usage > 80) {
        rootCauseList.forEach((element) => {
          if (element.containerMemory) {
            if (element.containerMemory.indexOf(device.container[i].name) === -1) {
              element.containerMemory.push(element.containerMemory.length === 0 ? `Penggunaan Memori pada container ${device.container[i].container_name} sebsar ${device.container[i].mem_usage}%` : `, ${device.container[i].container_name} sebesar ${device.container[i].mem_usage}%`);
            }
          }
        });
      }
    }
  }

  console.log("rootCauseList", rootCauseList);


  return {
    cpuData: tempCpu.sort((a, b) => b.value - a.value),
    cpuUserData: tempCpuUser.sort((a, b) => b.value - a.value),
    memoryData: tempMemory.sort((a, b) => b.value - a.value),
    storageData: tempStorage.sort((a, b) => b.value - a.value),
    rootCause: rootCauseList,
  };

}








